import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-course-create',
  templateUrl: './course-create.component.html',
  styleUrls: ['./course-create.component.scss']
})
export class CourseCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  submitted = false;
  public courseForm: FormGroup;
  public course = [];

  public editorContent: string = '';

  public editorConfig = {
    allowedContent: true, // disables filtering, keeps styles
    //extraAllowedContent: 'p(style);div(style);img(style); h1(style); h2(style); h3(style);h4(style); h5(style); h6(style); span(style);', // allows styles on specific tags
    extraAllowedContent: '*[style];', 
  };
  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/coursebyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.courseForm.patchValue({
              _id: data.data._id,
              stream: data.data.stream,
              specialization: data.data.specialization,
              course: data.data.course,
              deliverymode: data.data.deliverymode,
              award: data.data.award,
              duration: data.data.duration,
              faculty: data.data.faculty,
              program_details: data.data.program_details,
              extra_electives: data.data.extra_electives,
              slidertitle: data.data.slidertitle,
              // slideralt: data.data.slideralt,
              sliderimage: data.data.sliderimage,
              sliderdescription: data.data.sliderdescription,
              vision: data.data.vision,
              mission: data.data.mission,
              industryImmersion: data.data.industryImmersion,
              courseOutcome: data.data.courseOutcome,
              depcontact: data.data.depcontact,
              openday: data.data.openday,
              depbrochure: data.data.depbrochure,
              courselink: data.data.courselink,
              priority: data.data.priority,
              seotitle: data.data.seotitle,
              seokeywords: data.data.seokeywords,
              seotags: data.data.seotags,
              seodescription: data.data.seodescription,
              seohidden: data.data.seohidden,
             /*  overviewtitle: data.data.overviewtitle,
              overviewdesc: data.data.overviewdesc,
              overviewimagecaption: data.data.overviewimagecaption, */
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

    this.courseForm = this.formBuilder.group({
      stream: ['', Validators.required],
      specialization: ['', Validators.required],
      course: ['', Validators.required],
      deliverymode: ['', Validators.required],
      award: ['', Validators.required],
      duration: ['', Validators.required],
      faculty: ['', Validators.required],
      program_details: ['', Validators.required],
      extra_electives: ['', Validators.required],
      slidertitle: ['', Validators.required],
      // slideralt: ['', Validators.required],
      /* overviewtitle: ['', Validators.required],
      overviewdesc: ['', Validators.required],
      overviewimagecaption: ['', Validators.required], */
      sliderimage: ['', Validators.required],
      sliderdescription: [''],
      vision: [''],
      mission: [''],
      industryImmersion: [''],
      courseOutcome: [''],
      depcontact: ['', Validators.required],
      priority: ['', Validators.required],
      openday: [''],
      depbrochure: [''],
      courselink: [''],
      seotitle: [''],
      seokeywords: [''],
      seotags: [''],
      seodescription: [''],
      seohidden: [''],
      _id: ['']
    })
  }

  get f() { return this.courseForm.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.courseForm.invalid) {
      return;
    }

    if(this.action == 'Submit'){
    
    var data = {
      "stream" : this.courseForm.value.stream,
      "specialization" : this.courseForm.value.specialization,
      "course" : this.courseForm.value.course,
      "deliverymode" : this.courseForm.value.deliverymode,
      "award" : this.courseForm.value.award,
      "duration" : this.courseForm.value.duration,
      "faculty" : this.courseForm.value.faculty,
      "program_details" : this.courseForm.value.program_details,
      "extra_electives" : this.courseForm.value.extra_electives,
      "slidertitle" : this.courseForm.value.slidertitle,
      // "slideralt" : this.courseForm.value.slideralt,
      /* "overviewtitle" : this.courseForm.value.overviewtitle,
      "overviewdesc" : this.courseForm.value.overviewdesc,
      "overviewimagecaption" : this.courseForm.value.overviewimagecaption, */
      "courselink" : this.courseForm.value.courselink,
      "sliderimage": this.courseForm.value.sliderimage,
      "sliderdescription": this.courseForm.value.sliderdescription,
      "vision": this.courseForm.value.vision,
      "mission": this.courseForm.value.mission,
      "industryImmersion": this.courseForm.value.industryImmersion,
      "courseOutcome": this.courseForm.value.courseOutcome,
      "depcontact": this.courseForm.value.depcontact,
      "openday": this.courseForm.value.openday,
      "depbrochure": this.courseForm.value.depbrochure,
      "priority": this.courseForm.value.priority,
      "seotitle": this.courseForm.value.seotitle,
      "seokeywords": this.courseForm.value.seokeywords,
      "seotags": this.courseForm.value.seotags,
      "seodescription": this.courseForm.value.seodescription,
      "seohidden": this.courseForm.value.seohidden,
      "admin" : sessionStorage.getItem('adminName'),
    };
    console.log(data);
    this.http.post<any>(this.api_endpoint+'/courses', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/course/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured."+err);
      }
    });
  }else{
    var data1 = {
      "stream" : this.courseForm.value.stream,
      "specialization" : this.courseForm.value.specialization,
      "course" : this.courseForm.value.course,
      "deliverymode" : this.courseForm.value.deliverymode,
      "award" : this.courseForm.value.award,
      "duration" : this.courseForm.value.duration,
      "faculty" : this.courseForm.value.faculty,
      "program_details" : this.courseForm.value.program_details,
      "extra_electives" : this.courseForm.value.extra_electives,
      "slidertitle" : this.courseForm.value.slidertitle,
      // "slideralt" : this.courseForm.value.slideralt,
      /* "overviewtitle" : this.courseForm.value.overviewtitle,
      "overviewdesc" : this.courseForm.value.overviewdesc,
      "overviewimagecaption" : this.courseForm.value.overviewimagecaption, */
      "courselink" : this.courseForm.value.courselink,
      "sliderimage": this.courseForm.value.sliderimage,
      "sliderdescription": this.courseForm.value.sliderdescription,
      "vision": this.courseForm.value.vision,
      "mission": this.courseForm.value.mission,
      "industryImmersion": this.courseForm.value.industryImmersion,
      "courseOutcome": this.courseForm.value.courseOutcome,
      "depcontact": this.courseForm.value.depcontact,
      "openday": this.courseForm.value.openday,
      "depbrochure": this.courseForm.value.depbrochure,
      "priority": this.courseForm.value.priority,
      "seotitle": this.courseForm.value.seotitle,
      "seokeywords": this.courseForm.value.seokeywords,
      "seotags": this.courseForm.value.seotags,
      "seodescription": this.courseForm.value.seodescription,
      "seohidden": this.courseForm.value.seohidden,
      "admin" : sessionStorage.getItem('adminName'),
      "_id" : this.courseForm.value._id,
    };
      // console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/courses/', data1).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/course/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }

}
